import { ILegalTransactionRelationship } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import {
  getEmptyGeneralRelationship,
  IGeneralRelationship,
  isGeneralRelationship,
} from '../../../../Interfaces/ILegalTransactionRelationship/Relationships/General/ILegalTransactionRelationshipGeneral';

export const getExistingGeneralRelationship = (
  relationships: ILegalTransactionRelationship[]
): IGeneralRelationship | undefined => {
  return relationships.find(isGeneralRelationship);
};

export const getOrCreateGeneralRelationship = (
  relationships: ILegalTransactionRelationship[]
): IGeneralRelationship => {
  const existingRelationship = getExistingGeneralRelationship(relationships);

  if (existingRelationship) {
    return existingRelationship;
  }

  return getEmptyGeneralRelationship();
};
